(() => {
  if (window.TanatelListingShowcase) {
    window.TanatelListingShowcase.refresh(document);
    return;
  }

  const ROOT_SELECTOR = '[data-tanatel-listing-preview="true"]';
  const MEDIA_SELECTOR = [
    '.m-product-card--show-second-img .m-product-card__media',
    '.m-collection-card--has-hover-image .m-collection-card__image'
  ].join(',');
  const CARD_SELECTOR = '.m-product-card--show-second-img, .m-collection-card--has-hover-image';
  const SWIPE_DISTANCE = 28;
  const CLICK_GUARD_MS = 650;

  class TanatelTouchPreview {
    constructor(root) {
      this.root = root;
      this.start = null;
      this.guardedLink = null;
      this.guardedAt = 0;

      root.addEventListener('pointerdown', this.onPointerDown, { passive: true });
      root.addEventListener('pointerup', this.onPointerUp, { passive: true });
      root.addEventListener('pointercancel', this.reset, { passive: true });
      root.addEventListener('click', this.onClick, true);
    }

    onPointerDown = (event) => {
      if (event.pointerType === 'mouse' || event.isPrimary === false) return;

      const media = event.target.closest(MEDIA_SELECTOR);
      if (!media || !this.root.contains(media)) return;

      this.start = {
        pointerId: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        media
      };
    };

    onPointerUp = (event) => {
      if (!this.start || this.start.pointerId !== event.pointerId) return;

      const deltaX = event.clientX - this.start.x;
      const deltaY = event.clientY - this.start.y;
      const isHorizontalSwipe = Math.abs(deltaX) >= SWIPE_DISTANCE && Math.abs(deltaX) > Math.abs(deltaY) * 1.25;

      if (isHorizontalSwipe) {
        const card = this.start.media.closest(CARD_SELECTOR);
        const isRtl = getComputedStyle(this.root).direction === 'rtl';
        const revealSecondImage = isRtl ? deltaX > 0 : deltaX < 0;

        if (card) card.classList.toggle('is-touch-preview', revealSecondImage);
        this.guardedLink = this.start.media.closest('a');
        this.guardedAt = Date.now();
      }

      this.reset();
    };

    onClick = (event) => {
      if (!this.guardedLink || Date.now() - this.guardedAt > CLICK_GUARD_MS) return;
      if (event.target.closest('a') !== this.guardedLink) return;

      event.preventDefault();
      event.stopPropagation();
      this.guardedLink = null;
      this.guardedAt = 0;
    };

    reset = () => {
      this.start = null;
    };
  }

  const refresh = (scope = document) => {
    const roots = [];
    if (scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(ROOT_SELECTOR));

    roots.forEach((root) => {
      if (root.dataset.tanatelPreviewBound === 'true') return;
      root.dataset.tanatelPreviewBound = 'true';
      new TanatelTouchPreview(root);
    });
  };

  window.TanatelListingShowcase = { refresh };
  refresh(document);

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
})();
